import { Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";

type DismissibleProgressDialogProps = {
  open: boolean;
  title: string;
  body: string;
  onDismiss: () => void;
};

export function DismissibleProgressDialog({ open, title, body, onDismiss }: DismissibleProgressDialogProps) {
  return (
    <Dialog open={open} onOpenChange={(nextOpen) => { if (!nextOpen) onDismiss(); }}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription role="status" aria-live="polite">{body}</DialogDescription>
        </DialogHeader>
        <div className="flex flex-col items-center gap-4 py-4 w-full">
          <Loader2 className="h-8 w-8 animate-spin text-primary" />
        </div>
      </DialogContent>
    </Dialog>
  );
}
